import { useEffect } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import ProblemSection from "@/components/landing/ProblemSection";
import ProductSection from "@/components/landing/ProductSection";
import ShowcaseTabs from "@/components/landing/ShowcaseTabs";
import ChromeExtension from "@/components/landing/ChromeExtension";
import BetaSignup from "@/components/landing/BetaSignup";
import FrameworkSection from "@/components/landing/FrameworkSection";
import Ticker from "@/components/landing/Ticker";
import Footer from "@/components/landing/Footer";
import { captureAttribution } from "@/lib/analytics";

export default function Landing() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-white text-ink font-sans selection:bg-brand-orange selection:text-ink"
    >
      <Nav />
      <Hero />
      <ProblemSection />
      <ProductSection />
      <ShowcaseTabs />
      <ChromeExtension />
      <BetaSignup />
      <FrameworkSection />
      <Ticker />
      <Footer />
    </main>
  );
}
